/**
 * Видимость приложения по событию документа — общая часть Web и Telegram.
 * VK добавляет к ней собственные события моста (VKWebAppViewHide/Restore).
 */
export function subscribeDocumentVisibility(listener: (visible: boolean) => void): () => void {
  const handler = () => listener(document.visibilityState !== 'hidden');

  document.addEventListener('visibilitychange', handler);
  return () => document.removeEventListener('visibilitychange', handler);
}
